export const cleanSearchQuery = (query: string) =>
  query?.trim().replace(/[-+()"']/gi, ' ')

/**
 * Converts a relative date string to a JSON date string
 * The input can be a number (relative date) or a string (absolute date)
 * Example: (check 'relativeDatesFactory' for more details)
 *        - '-1' -> it means yesterday
 *        - '0' -> it means today
 *        - '1' -> it means tomorrow
 *        - '-604800' -> it means 7 days ago
 *        - '-2592000' -> it means 30 days ago
 *        - '2024-01-09' -> it means the date is 2024-01-09
 * @param dateString - The relative date string to convert
 * @returns The JSON date string
 */
export const getFormattedJSONDate = (dateString: string) => {
  // Check if the input is a number (relative dateString)
  const isNumber = /^-?\d+$/.test(dateString)

  if (isNumber) {
    const seconds = parseInt(dateString, 10)
    const now = new Date()
    // Add seconds to current date (multiply by 1000 to convert to milliseconds)
    const targetDate = new Date(now.getTime() + seconds * 1000)
    // Format as YYYY-MM-DD
    return JSON.stringify(targetDate.toISOString().split('T')[0])
  }

  // If it's already in YYYY-MM-DD format, just return it
  return JSON.stringify(dateString)
}
